import {ID, Response} from '../../../../../../_metronic/helpers'
export type User = {
  _id?: ID
  fullName?: string
  avatar?: string
  email?: string
  createdAt?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: '/media/avatars/blank.png',
  position: 'Art Director',
  role: 'Administrator',
  fullName: '',
  email: '',
}
